import styles from './SLSecurityCheckBanner.module.css';
import { Button } from '@iwoca/orion';
import { WarningTriangleSVG } from '@svgComponents/warningTriangleSVG';
import {
    useGetFundingRequirementsIwocaPay,
    useGetSpendingLimitRequest
} from '@api/lendingAPI/lapiHooks';
import { checkAnyRequirementsVisible } from '../Dashboard.helpers';

const goToSecurityCheck = () => {
    window.location.pathname = `/pay/security-checks/`;
};

export const useGetSecurityCheckRequirements = () => {
    const { fundingRequirement, loadingFundingRequirement } =
        useGetFundingRequirementsIwocaPay();

    const isAnyRequirementVisible = checkAnyRequirementsVisible(
        fundingRequirement!,
        [
            'onfido_check',
            'add_default_payment_method',
            'major_shareholders_check'
        ]
    );

    return {
        isAnyRequirementVisible,
        fundingRequirement,
        loadingFundingRequirement
    };
};

export const SLSecurityCheckBanner = () => {
    const { isAnyRequirementVisible, loadingFundingRequirement } =
        useGetSecurityCheckRequirements();
    const { spendingLimitRequest, loadingSpendingLimitRequest } =
        useGetSpendingLimitRequest();

    if (loadingSpendingLimitRequest || loadingFundingRequirement) {
        return null;
    }

    if (!spendingLimitRequest?.uuid || !isAnyRequirementVisible) return null;

    return (
        <section className={styles.banner}>
            <div className={styles.headerContainer}>
                <WarningTriangleSVG className={styles.warningTriangle} />
                <div>
                    <h2 className={styles.header}>
                        You'll need to do some security checks before using your
                        spending limit
                    </h2>
                </div>
                <div>
                    <p>
                        You can do them now, or when you're making your first
                        purchase using iwocaPay.
                    </p>
                </div>
            </div>
            <Button
                variant="primary"
                onClick={goToSecurityCheck}
                className={styles.button}
            >
                Finish security checks
            </Button>
        </section>
    );
};
